import React from "react";
import { useOutletContext } from "react-router-dom";
import Employees from "../../components/Company/Employee/Employees";

const CompanyEmployees = () => {
  const { page, setIsModalOpen } = useOutletContext();

  return <Employees page={page} setIsModalOpen={setIsModalOpen} />;
};

export default CompanyEmployees;